/* eslint-disable react/no-unescaped-entities */
import { AbdooLogo } from '@abdoo/common';
import { Grid, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import smallerLogo from '../logos/Abdoo logo + safe area_128px-height.png';
import smallLogo from '../logos/Abdoo logo + safe area_256px-height.png';
export const NotFoundComponent = () => {
  return (
    <>
      <Grid container justifyContent="center">
        <AbdooLogo
          sx={{
            content: {
              md: `url(${smallLogo})`,
              xs: `url(${smallerLogo})`,
            },
          }}
        />
      </Grid>
      <Grid container justifyContent="center" textAlign="center">
        <Grid item xs={12}>
          <Typography>
            Looks like the page you're looking for has gone "absent"...
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: '1em' }}>
          <Typography>
            Head back to <Link to="/calendar">calendar</Link>
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
